import { render, staticRenderFns } from "./ZonesBasic.vue?vue&type=template&id=ed5241f6&scoped=true&"
import script from "./ZonesBasic.vue?vue&type=script&lang=js&"
export * from "./ZonesBasic.vue?vue&type=script&lang=js&"
import style0 from "./ZonesBasic.vue?vue&type=style&index=0&id=ed5241f6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed5241f6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VSpacer})
